export default {
  buttons: {
    title1: 'Beskær',
    title2: 'Luk',
  },
};
